import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface OpenNowDueNoticeProps {
    text: string;
}

export function OpenNowDueNotice({ text }: OpenNowDueNoticeProps) {
    return (
        <div className="px-5 py-3">
            <div
                role="status"
                className="flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-900"
            >
                <ExclamationTriangleIcon className="w-5 h-5 flex-shrink-0 text-amber-700" />
                <span className="min-w-0">{text}</span>
            </div>
        </div>
    );
}
